import router from "./routes";
import store from "./store";    
function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}
const sortTasks = (payload) => {
    if (!payload) return;
	let namespaceStorageKey = "";
	let namespace = "";
	let deliverablesModule = "deliverables";

    if(router.currentRoute.name == 'deliverable-templates') {
        deliverablesModule = 'deliverableTemplates'
        payload.deliverables = payload.deliverableTemplates;
    }

	if (!payload.deliverables) return;
	if (typeof payload.namespace != "undefined") {
		namespaceStorageKey = payload.namespace.replace("/","") + "__";
		namespace = payload.namespace;
		if (namespace != "") {
			deliverablesModule = payload.namespace.replace("/", "");
		}
	}


    // Hardcode for sort by due date
    localStorage.setItem(namespaceStorageKey + 'storedSortKey', 'due_date');
    localStorage.setItem(namespaceStorageKey + 'storedSortFieldId', 12);
    localStorage.setItem(namespaceStorageKey + 'storedSortState', 'ASC');
    payload.sortKey = 'due_date';
    payload.fieldId = 12;
    payload.sortKey = 'ASC';
    payload.sortFields = false;

    let isDeliverableArray =  Array.isArray(payload.deliverables)
    if(!isDeliverableArray && typeof payload.deliverables.nextWeek == 'undefined') {
        payload.deliverables = [payload.deliverables]
    }
    let storedSortState = false
    let storedSortKey = localStorage.getItem(namespaceStorageKey + 'storedSortKey')
    if(typeof payload.fieldId != 'undefined') {
        localStorage.setItem(namespaceStorageKey + 'storedSortFieldId', payload.fieldId)
        store.state[""+deliverablesModule].storedSortFieldId = payload.fieldId
    } else {
        payload.fieldId = localStorage.getItem(namespaceStorageKey + 'storedSortFieldId')
    }
    if(!payload.sortKey) {
        if(storedSortKey) { // last set sort option by the user
            payload.sortKey = storedSortKey
            storedSortState = localStorage.getItem(namespaceStorageKey + 'storedSortState')
        } else { // default sorting === any sorting will not be applied to data
            localStorage.setItem(namespaceStorageKey + 'storedSortState', 'ASC')
            localStorage.setItem(namespaceStorageKey + 'nextSortState', 'DESC')
            localStorage.setItem(namespaceStorageKey + 'storedSortKey', 'created_date')
            store.state[""+deliverablesModule].storedSortKey = 'created_date'
            store.state[""+deliverablesModule].nextSortState = 'DESC'
            store.state[""+deliverablesModule].storedSortState = 'ASC'
        }
    } else { 
        storedSortState = localStorage.getItem(namespaceStorageKey + 'nextSortState')
        if(!storedSortState || storedSortKey != payload.sortKey) {
            storedSortState = payload.sortKey == 'created_date' ? 'DESC' : 'ASC'
        } 
        localStorage.setItem(namespaceStorageKey + 'storedSortState', storedSortState)
        localStorage.setItem(namespaceStorageKey + 'nextSortState', storedSortState == 'ASC' ? 'DESC' : 'ASC')
        localStorage.setItem(namespaceStorageKey + 'storedSortKey', payload.sortKey)
        store.state[""+deliverablesModule].storedSortKey = payload.sortKey
        store.state[""+deliverablesModule].nextSortState = storedSortState
        store.state[""+deliverablesModule].storedSortState = storedSortState
    }
    if(typeof payload.sortFields != 'undefined' && payload.sortFields) {
        sortTaskFields({namespace:namespace})
    }
    if(payload.deliverables) {
        if(router.currentRoute.name == 'myWeek') {
            if(typeof payload.deliverables.nextWeek != 'undefined') {
                payload.deliverables = payload.deliverables.nextWeek.concat(payload.deliverables.noDeadline, payload.deliverables.overdue, payload.deliverables.thisWeek, payload.deliverables.today, payload.deliverables.upcoming)
            }
        }

        switch(payload.sortKey) {
            case 'created_date':
                localStorage.setItem(namespaceStorageKey + 'storedSortFieldId', null)
                store.state[""+deliverablesModule].storedSortFieldId = null
                let storedTaskOrder = store.state[""+deliverablesModule].storedTaskOrder
                //console.log(storedTaskOrder)
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.sort((x, y) => {
                        if(storedSortState == 'ASC') {
                            if(storedTaskOrder !== null && typeof storedTaskOrder[deliverable.id] != 'undefined') {
                                var A = x['id'], B = y['id'];
                                return (storedTaskOrder[deliverable.id].indexOf(A) > storedTaskOrder[deliverable.id].indexOf(B)) ? 1 : -1
                                // return (x.id == y.display_order) ? 1 : -1
                            } else {
                                return (x.id > y.id) ? 1 : -1
                            }
                        } else {
                            if(storedTaskOrder !== null && typeof storedTaskOrder[deliverable.id] != 'undefined') {
                                var A = x['id'], B = y['id'];
                                return (storedTaskOrder[deliverable.id].indexOf(A) < storedTaskOrder[deliverable.id].indexOf(B)) ? 1 : -1
                                // return (x.display_order < y.display_order) ? 1 : -1
                            } else {
                                return (x.id < y.id) ? 1 : -1
                            }
                        }
                    })
                })
                break
            case 'user':
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return
                                if(taskField.value != null && taskField.value != '') {
                                    if(storedSortState == 'ASC') {
                                        return (x.taskFields[key].userName.toUpperCase() > y.taskFields[key].userName.toUpperCase()) ? 1 : -1
                                    } else {
                                        return (x.taskFields[key].userName.toUpperCase() < y.taskFields[key].userName.toUpperCase()) ? 1 : -1
                                    }
                                }
                            })
                        })
                    })
                })
                break
            case 'status':
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return
                                if(taskField.value != null && taskField.value != '') {
                                    if(isJSON(x.taskFields[key].value)) {
                                        x.taskFields[key].value = JSON.parse(x.taskFields[key].value)
                                    }
                                    if(isJSON(y.taskFields[key].value)) {
                                        y.taskFields[key].value = JSON.parse(y.taskFields[key].value)
                                    }
                                    if(storedSortState == 'ASC') {
                                        return x.taskFields[key].value.name > y.taskFields[key].value.name ? 1 : -1
                                    } else {
                                        return x.taskFields[key].value.name < y.taskFields[key].value.name ? 1 : -1
                                    }
                                }
                            })
                        })
                    })
                })
                break
            default:
                payload.deliverables.forEach((deliverable, key) => {
                    deliverable.tasks.forEach((task, key) => {
                        task.taskFields.forEach((taskField, key) => {
                            deliverable.tasks.sort((x, y) => {
                                if(taskField.field_id != payload.fieldId) return

                                // START new task type sorting
                                if(x.task_type_id > y.task_type_id){
                                    return 1;
                                }
                                if(y.task_type_id > x.task_type_id){
                                    return -1;
                                }
                                if(y.task_type_id ==  x.task_type_id){
                                	if (typeof x.display_order != "undefined") {
	                        		   	if (x.display_order > y.display_order) {
	                        				return 1;
	                        			} else {
	                        				return -1;
	                        			}
                                	} else {
	                                   	if (x.id > y.id) {
	                                		return 1;
	                                	} else {
	                                		return -1;
	                                	}
	                                }
                                }
                                // END new task type sorting


                                if(x.taskFields[key].value === null || x.taskFields[key].value === '') {
                                    return 1
                                } 
                                if(y.taskFields[key].value === null || y.taskFields[key].value === '') {
                                    return -1
                                } 
                                if(storedSortState == 'ASC') {
                                    return (x.taskFields[key].value > y.taskFields[key].value) ? 1 : -1
                                } else {
                                    return (x.taskFields[key].value < y.taskFields[key].value) ? 1 : -1
                                }
                            })
                        })
                    })
                })
                break
        }
        if(!isDeliverableArray) {
            payload.deliverables = payload.deliverables[0]
        }
        if(typeof payload.return != 'undefined') {
            return isDeliverableArray ? payload.deliverables : payload.deliverables[0]
        }
    }
}

const sortTaskFields = (payload) => {
	let namespaceStorageKey = "";
	let namespace = "";
	let deliverablesModule = "deliverables";

    if(typeof payload.deliverables == 'undefined') {
        deliverablesModule = 'deliverableTemplates'
        payload.deliverables = payload.deliverableTemplates;
    }

	if (typeof payload.namespace != "undefined") {
		namespaceStorageKey = payload.namespace.replace("/","") + "__";
		namespace = payload.namespace;
		if (namespace != "") {
			deliverablesModule = payload.namespace.replace("/", "");
		}
	}


    let order = []
    if(!payload.fieldOrderData) {
        order = store.state[""+deliverablesModule].storedTaskFieldsOrder
    } else {
        order[payload.deliverableTemplateId] = []
        payload.fieldOrderData.forEach((val, key) => {
            order[payload.deliverableTemplateId].push(val.field_id)
        })
        store.state[""+deliverablesModule].storedTaskFieldsOrder = order
    }
    //console.log(order)
    
    store.state[""+deliverablesModule].storedTaskFieldsOrder = order
    let deliverableTemplateId = ''
    if(router.currentRoute.name == 'dashboard') {
        if(typeof store.state[""+deliverablesModule].deliverables != 'undefined') {
            for (let x = 0; x < Object.keys(store.state[""+deliverablesModule].deliverables).length; x++) {
                deliverableTemplateId = store.state[""+deliverablesModule].deliverables[x].deliverable_template_id
                if (typeof store.state[""+deliverablesModule].deliverables[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state[""+deliverablesModule].deliverables[x].tasks.length; y++) {
                        store.state[""+deliverablesModule].deliverables[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }

    if(router.currentRoute.name == 'myWeek') {
        if (typeof store.state[""+deliverablesModule].unGroupedUserDeliverables.data != "undefined" && store.state[""+deliverablesModule].unGroupedUserDeliverables.data.length) {
            for (let x = 0; x < Object.keys(store.state[""+deliverablesModule].unGroupedUserDeliverables.data).length; x++) {
                deliverableTemplateId = store.state[""+deliverablesModule].unGroupedUserDeliverables.data[x].deliverable_template_id
                if (typeof store.state[""+deliverablesModule].unGroupedUserDeliverables.data[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state[""+deliverablesModule].unGroupedUserDeliverables.data[x].tasks.length; y++) {
                        store.state[""+deliverablesModule].unGroupedUserDeliverables.data[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }
    
    if(router.currentRoute.name == 'projectDeliverable' || router.currentRoute.name == 'project' || router.currentRoute.name == 'myProjects') {
        if(typeof store.state[""+deliverablesModule].projectDeliverables != 'undefined') {
            for (let x = 0; x < Object.keys(store.state[""+deliverablesModule].projectDeliverables).length; x++) {
                deliverableTemplateId = store.state[""+deliverablesModule].projectDeliverables[x].deliverable_template_id
                if (typeof store.state[""+deliverablesModule].projectDeliverables[x] != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
                    for(let y = 0; y < store.state[""+deliverablesModule].projectDeliverables[x].tasks.length; y++) {
                        store.state[""+deliverablesModule].projectDeliverables[x].tasks[y].taskFields.sort((a, b) => {
                            var A = a['field_id'], B = b['field_id'];
                            return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
                        })
                    }
                }
            }
        }
    }

    deliverableTemplateId = store.state[""+deliverablesModule].deliverableDetail.deliverable_template_id
    if (typeof store.state[""+deliverablesModule].deliverableDetail != "undefined" && typeof store.state[""+deliverablesModule].deliverableDetail.tasks != 'undefined' && typeof order[deliverableTemplateId] != 'undefined') {
        for(let y = 0; y < store.state[""+deliverablesModule].deliverableDetail.tasks.length; y++) {
            store.state[""+deliverablesModule].deliverableDetail.tasks[y].taskFields.sort((a, b) => {
                var A = a['field_id'], B = b['field_id'];
                return (order[deliverableTemplateId].indexOf(A) > order[deliverableTemplateId].indexOf(B)) ? 1 : -1
            })
        }
    }
}


const getPlural = (count, single, plural)  => {
	if (count == 1) {
		return single;
	}
	return plural;
}

const getPostPlural = (count) => {
	if (count == 1) {
		return "post";
	}
	return "posts";
}


export { sortTasks, sortTaskFields, getPlural, getPostPlural}